<template>
  <div class="winStats" v-if="stats">
    <span> <GameResult :gameResult="1" /> {{ stats.wins }} </span>
    <span> <GameResult :gameResult="2" /> {{ stats.draws }} </span>
    <span> <GameResult :gameResult="0" /> {{ stats.losses }} </span>
    <span v-if="stats.disqualified">
      <GameResult :gameResult="11" /> {{ stats.disqualified }}
    </span>
    <!-- <span v-if="stats.longest_win_streak">
      <div>
        <b-tooltip label="Longest win streak" type="is-success">
          <span style="font-size: 1rem">✨</span>
        </b-tooltip>
      </div>
      {{ stats.longest_win_streak }}
    </span> -->
  </div>
</template>

<script>
import GameResult from "@/components/games/GameResult.vue";

export default {
  components: { GameResult },

  props: ["stats"],
};
</script>

<style scoped>
.winStats {
  width: 150px;
  display: flex;
  justify-content: space-between;
}

.winStats span {
  font-size: 0.85em;
}
</style>
